import { Component, OnInit, ViewChild } from '@angular/core';
import { ApiService } from '../../../../services/main/api.service';
import { NgbModal, ModalDismissReasons, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Storage } from '@ionic/storage';
import { Router, ActivatedRoute } from '@angular/router';
import { Global } from '../../../../services/global';
import { BaseCrudComponent } from '../../../base-crud/base-crud.component';
import { TranslateService } from '@ngx-translate/core';
import { Observable, BehaviorSubject, of, throwError, from, concat } from 'rxjs';
import { mergeMap, catchError, timeout, retry } from 'rxjs/operators';
import { ExportAsService, ExportAsConfig } from 'ngx-export-as';
import * as moment from 'moment-timezone';

import { LazyLoadEvent } from 'primeng/api';
import { SelectItem } from 'primeng/api';
import {MessageService} from 'primeng/api';

@Component({
  selector: 'app-routesreport',
  templateUrl: './routesreport.component.html',
  styleUrls: ['./routesreport.component.css']
})
export class RoutesreportComponent extends BaseCrudComponent {

  	exportAsConfig: ExportAsConfig = {
        type: 'xlsx',
        elementIdOrContent: 'exportable'
    };

  	translations:any;
	header:any;
	theaders:any;
	momentjs: any = moment;
    curr_date:any;
    today:any;
    dstart:any;
    dend:any;
    
    totals:any;
    frozenCols:any;
    loadingRequired = false;

    //filters data
    dropdowns:any;
    sr_filter:any;
    hr_filter:any;
    driver_filter:any;
    ds_filter:any;
    rs_filter:any;

    sel_delivery:any;


	constructor(
	    srv: ApiService,
	    modalService: NgbModal,
	    storage: Storage,
  		router: Router,
  		private route: ActivatedRoute,
        public translate: TranslateService,
        private exportAsService: ExportAsService
	  ) {
	    super(srv, modalService, storage, router);
	    this.read_url = 'LogisticRoute/ReportDetail';
        this.header = {};
        this.rows = [];
        this.totals = [];
        this.dropdowns = [];

        this.frozenCols = [
            //{ field: 'guideNumber', header: 'Guia', sortable:true, sortfield:'', styleC:{'text-align':'center'}, width:{'width.px': 180}, isColor:false, pre:'', pos:'', total:'', filter:'input'}
        ];

        this.theaders = [
        	{ field: 'guideNumber', header: 'Guia', sortable:true, sortfield:'', styleC:{'text-align':'center'}, width:{'width.px': 180}, isColor:false, pre:'', pos:'', total:'', filter:'input'},
            { field: 'createdTimeStamp', header: 'Fecha', sortable:true, sortfield:'', styleC:{'text-align':'center'}, width:{'width.px': 220}, isColor:false, pre:'', pos:'', total:''},
            { field: 'package', header: 'Embalaje', sortable:true, sortfield:'', styleC:{'text-align':'center'}, width:{'width.px': 200}, isColor:false, pre:'', pos:'', total:''},
            { field: 'quantity', header: 'Cantidad', sortable:true, sortfield:'', styleC:{'text-align':'center'}, width:{'width.px': 150}, isColor:false, pre:'', pos:'', total:''},
            { field: 'weight', header: 'Peso', sortable:true, sortfield:'', styleC:{'text-align':'center'}, width:{'width.px': 150}, isColor:false, pre:'', pos:'', total:''},
            { field: 'deliveryNumber', header: 'Entrega', sortable:true, sortfield:'', styleC:{'text-align':'center'}, width:{'width.px': 150}, isColor:false, pre:'', pos:'', total:''},
            { field: 'invoiceNumber', header: 'Factura', sortable:true, sortfield:'', styleC:{'text-align':'center'}, width:{'width.px': 150}, isColor:false, pre:'', pos:'', total:''},
            { field: 'clientName', header: 'Nobre Cliente', sortable:true, sortfield:'', styleC:{'text-align':'center'}, width:{'width.px': 350}, isColor:false, pre:'', pos:'', total:''},
            { field: 'recipientCode', header: 'Código Destinatario', sortable:true, sortfield:'', styleC:{'text-align':'center'}, width:{'width.px': 150}, isColor:false, pre:'', pos:'', total:''},
            { field: 'province', header: 'Provincia', sortable:true, sortfield:'', styleC:{'text-align':'center'}, width:{'width.px': 200}, isColor:false, pre:'', pos:'', total:''},
            { field: 'recipientCity', header: 'Ciudad Destinatario', sortable:true, sortfield:'', styleC:{'text-align':'center'}, width:{'width.px': 200}, isColor:false, pre:'', pos:'', total:''},
            { field: 'recipientAddress', header: 'Dirección', sortable:true, sortfield:'', styleC:{'text-align':'center'}, width:{'width.px': 350}, isColor:false, pre:'', pos:'', total:''},
            { field: 'routeSap', header: 'Ruta SAP', sortable:true, sortfield:'', styleC:{'text-align':'center'}, width:{'width.px': 200}, isColor:false, pre:'', pos:'', total:'', filter:'multi'},
            { field: 'routeName', header: 'Ruta Hivi', sortable:true, sortfield:'', styleC:{'text-align':'center'}, width:{'width.px': 350}, isColor:false, pre:'', pos:'', total:'', filter:'multi'},
            { field: 'deliveryStatus', header: 'Estado Entrega', sortable:true, sortfield:'', styleC:{'text-align':'center'}, width:{'width.px': 200}, isColor:false, pre:'', pos:'', total:''},
            { field: 'causal', header: 'Causal', sortable:true, sortfield:'', styleC:{'text-align':'center'}, width:{'width.px': 200}, isColor:false, pre:'', pos:'', total:''},
            { field: 'driverName', header: 'Conductor', sortable:true, sortfield:'', styleC:{'text-align':'center'}, width:{'width.px': 250}, isColor:false, pre:'', pos:'', total:'', filter:'multi'},
            { field: 'sapTransport', header: 'Transporte SAP', sortable:true, sortfield:'', styleC:{'text-align':'center'}, width:{'width.px': 200}, isColor:false, pre:'', pos:'', total:''},
            { field: 'hiviTransport', header: 'Transporte Hivi', sortable:true, sortfield:'', styleC:{'text-align':'center'}, width:{'width.px': 200}, isColor:false, pre:'', pos:'', total:''},
            { field: 'isNearTime', header: 'H. Arribo Destino', sortable:true, sortfield:'', styleC:{'text-align':'center'}, width:{'width.px': 220}, isColor:false, pre:'', pos:'', total:''},
            { field: 'deliveredTime', header: 'H. Entregado', sortable:true, sortfield:'', styleC:{'text-align':'center'}, width:{'width.px': 220}, isColor:false, pre:'', pos:'', total:''},
            { field: 'score', header: 'Puntaje Serv. Cliente', sortable:true, sortfield:'', styleC:{'text-align':'center'}, width:{'width.px': 150}, isColor:false, pre:'', pos:'', total:''},
            { field: 'coordinate', header: 'Coordenadas', sortable:true, sortfield:'', styleC:{'text-align':'center'}, width:{'width.px': 250}, isColor:false, pre:'', pos:'', total:''}
        ];
    }

    ngOnInit() {
        /*this.curr_date = this.momentjs().tz('America/Guayaquil').format('YYYY-MM-DD');
        this.today = this.momentjs().tz('America/Guayaquil').format('YYYY-MM-DD');
        this.f_datefrom = this.curr_date;
        this.f_dateto = this.curr_date;*/

        this.clearFilters();

    	this.translate.getTranslation(this.translate.currentLang)
        .subscribe((translations) => {
            this.translations = translations;
            super.ngOnInit();

            var batch = [];
            batch.push(this.getSapRoutes());
            batch.push(this.getHiviRoutes());
            batch.push(this.getRouteStatus());
            batch.push(this.getDestinyStatus());
            batch.push(this.getDrivers());

            this.loadingRequired = true;

	        concat(...batch).subscribe({
	        	complete: () => {
	        		this.loadingRequired = false;
	        		/*console.log('Complete');
	        		console.log(this.dropdowns);*/
	        		this.getList();
	        	}
	        });
        });
    }

    clearData(){
        this.header = {};
        this.rows = [];
        this.totals = [];
    }

    public getList(){
        var qst = this.read_url;
        var obj:any;
        //this.f_datefrom = '2020-09-01';
        this.clearData();

        obj = {
            Start: this.f_datefrom,
            End: this.f_dateto,
            DriverId: this.driver_filter,
            RouteId: this.hr_filter,
            SapRoute: this.sr_filter,
            RouteStatusId: this.rs_filter,
            StatusDestinationId: this.ds_filter
        }

        if( (this.f_custom1 != null) && (this.f_custom1 != 'null') ){
        	obj.Zone = this.f_custom1;
        }

        this.loadingList = true;
        //console.log(obj);

        this.srv.postCall(qst, obj).subscribe(x => {
        	this.loadingList = false;

            if(x.status){
                var rs = x.data;
                this.rows = rs;
                /*this.totals = rs.totals;
                this.totalsCat = rs.totalsByCategories;
                this.cats = this.getDynamicHeaders(this.rows);
                this.catcount = Array(rs.detail.groupsNumber * 3).fill(0).map((x,i)=>i);

                this.rows.forEach(r => {
                    r.semaforo_var = this.getColor(r.porcenVariacionTotal);
                    r.sort_ventaTotal = parseFloat(r.ventaTotal.replace(/,/g, ''));
                    r.sort_ventaTotalAnterior = parseFloat(r.ventaTotalAnterior.replace(/,/g, ''));
                    r.sort_variacionTotal = parseFloat(r.variacionTotal.replace(/,/g, ''));
                    r.sort_porcenVariacionTotal = parseFloat(r.porcenVariacionTotal.replace(/,/g, ''));
                });
                
                this.cats.forEach(c => {
                	this.innercats.push('VTA NETA');
                	this.innercats.push('VTA PROM MES AÑO X-1');
                	this.innercats.push('$ VAR');
                });*/
            }
        });
    }

    getColor(par:any){
        var r:any;
        par = parseFloat(par.replace(/,/g, ''));
        r = {};

        if(par <= 0){
            //red
            r.color = '#ff0000';
            r.colorClass = 'orangered';
        }
        else if(par > 5){
            //green
            r.color = '#adff2f';
            r.colorClass = 'greenyellow';
        }
        else{
            //yellow
            r.color = '#ffff00';
            r.colorClass = 'yellow';
        }

        return r;
    }

    public getDynamicHeaders(rows:any){
    	var resp = [];

    	if( Array.isArray(rows) && (rows.length > 0) ){
    		rows.forEach(x => {
    			x.categories.forEach(c => {
    				let cat = c.nombreCategoria;
    				if( resp.indexOf(cat) < 0 ){
    					resp.push(cat);
    				}
    			});
    		});
    	}

    	return resp;
    }

    public getRouteStatusFilters(){
        var par_url = 'ZoneBP/ListByUser';

        return this.srv.getCall(par_url).pipe(
                    mergeMap(data => {
                        let mydata:any = {status: false, data: [], message: ''};
                        mydata = data;
                        //console.log(data);
                        
                        if( mydata.status ){
                          return of(mydata.data);
                        }
                        else{
                          return of(false);
                        }
                      }),
                      //timeout(MAX_TIME),
                      catchError(data => {return of(false)})
                );
    }

    public getSapRoutes(){
        var par_url = 'LogisticRoute/GetSapRoutes';

        return this.srv.getCall(par_url).pipe(
                    mergeMap(x => {
                        let mydata:any = {status: false, message:'', data:[]};
                        mydata = x;
                        
                        if(mydata.status == true ){
                        	//console.log(mydata.data);
                        	let r = mydata.data;
                        	this.dropdowns['routeSap'] = [];

                          	r.forEach(y => {
	                            //this.dropdowns['routeSap'].push({name: y.description, code: y.code});
	                            this.dropdowns['routeSap'].push({name: y.description, code: y.description});
	                        });
                          	return of(true);
                        }
                        else{
                          	return of(false);
                        }
                      }),
                      //timeout(MAX_TIME),
                      catchError(data => of(false))
                );
    }

    public getHiviRoutes(){
        var par_url = 'LogisticRoute/All';

        return this.srv.getCall(par_url).pipe(
                    mergeMap(x => {
                        let mydata:any = {status: false, message:'', data:[]};
                        mydata = x;
                        
                        if(mydata.status == true ){
                        	//console.log(mydata.data);
                        	let r = mydata.data;
                        	this.dropdowns['routeName'] = [];
                          	
                          	r.forEach(y => {
	                            this.dropdowns['routeName'].push({name: y.name, code: y.id});
	                        });
                          	return of(true);
                        }
                        else{
                          	return of(false);
                        }
                      }),
                      //timeout(MAX_TIME),
                      catchError(data => of(false))
                );
    }

    public getRouteStatus(){
        var par_url = 'SystemParameter/GetByName/ROUTE_STATUS';

        return this.srv.getCall(par_url).pipe(
                    mergeMap(x => {
                        let mydata:any = {status: false, message:'', data:[]};
                        mydata = x;
                        
                        if(mydata.status == true ){
                        	//console.log(mydata.data);
                        	let r = mydata.data;
                        	this.dropdowns['routeStatus'] = [];
                          	
                          	if( Array.isArray(r) ){
                          		r[0].forEach(y => {
		                            this.dropdowns['routeStatus'].push({name: y.name, code: y.id});
		                        });
                          	}
                          	
                          	return of(true);
                        }
                        else{
                          	return of(false);
                        }
                      }),
                      //timeout(MAX_TIME),
                      catchError(data => of(false))
                );
    }

    public getDestinyStatus(){
        var par_url = 'SystemParameter/GetByName/STATUS';

        return this.srv.getCall(par_url).pipe(
                    mergeMap(x => {
                        let mydata:any = {status: false, message:'', data:[]};
                        mydata = x;
                        
                        if(mydata.status == true ){
                        	//console.log(mydata.data);
                        	let r = mydata.data;
                        	this.dropdowns['destinyStatus'] = [];

                        	if( Array.isArray(r) ){
                          		r[0].forEach(y => {
		                            this.dropdowns['destinyStatus'].push({name: y.name, code: y.id});
		                        });
                          	}
                          	
                          	return of(true);
                        }
                        else{
                          	return of(false);
                        }
                      }),
                      //timeout(MAX_TIME),
                      catchError(data => of(false))
                );
    }

    public getDrivers(){
        var par_url = 'LogisticDriver/All';

        return this.srv.getCall(par_url).pipe(
                    mergeMap(x => {
                        let mydata:any = {status: false, message:'', data:[]};
                        mydata = x;
                        
                        if(mydata.status == true ){
                        	//console.log(mydata.data);
                        	let r = mydata.data;
                        	this.dropdowns['driverName'] = [];
                          	
                          	r.forEach(y => {
	                            this.dropdowns['driverName'].push({name: y.name, code: y.id});
	                        });
                          	return of(true);
                        }
                        else{
                          	return of(false);
                        }
                      }),
                      //timeout(MAX_TIME),
                      catchError(data => of(false))
                );
    }

    public clearFilters(){
    	this.sr_filter = '';
	    this.hr_filter = '';
	    this.driver_filter = '';
	    this.ds_filter = '';
	    this.rs_filter = '';

	    let today = this.momentjs().tz('America/Guayaquil').format('YYYY-MM-DD');
        this.f_datefrom = today;
        this.f_dateto = today;
    }

    exportReport(){
        this.exportAsService.save(this.exportAsConfig, 'reporte_rutas').subscribe(() => {
          // save started
        });
    }

    showTracking(content:any, id){
        this.sel_delivery = id;
        console.log(this.sel_delivery);
        super.openCreateModalLG(content);
    }

}
